import { Component, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AppInformationService, AuthenticationService, RAFUnitOfWork } from '../../core/core.module';
import * as _ from 'lodash';
import { core } from 'breeze-client';
import { confirm, alert } from 'devextreme/ui/dialog';
import { EmailMessage } from 'src/app/core/data/entities';
import validationEngine from 'devextreme/ui/validation_engine';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-email-dialog',
    templateUrl: './email-dialog.component.html',
    styleUrls: ['./email-dialog.component.scss'],
    standalone: false
})
export class EmailDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    mode = 'Invoice';
    entityId: any;
    defaultEmailAddress: any;
    entity: any;
    email: any;

    validationGroup = 'mainValidationGroup';
    errorAction = 'saving';

    processing = false;

    emailBodyMain = `Dear Customer,\r\n\r\nYour invoice is attached.  Please remit payment at your earliest convenience.`;
    emailBodyCreditCard = `We do accept payments by credit card for a 3% processing fee.  To use this option, click the hyperlink below and follow the prompts. When complete, click the "pay now" button.`;
    emailSignature = `\r\nPlease note our new mailing address below, also listed on your invoice, as we have moved! Please update all your Bill pay systems with our new address as well.\r\n\r\nThank you for your business!  We appreciate you choosing us for your electrical needs and look forward to working with you in the future!\r\n\r\nSincerely,\r\n\r\nRAF Electric Inc.\r\n\r\nBob Firmiss\r\nM 616.836.4451  O 269.543.3017\r\n\r\nPO Box 136\r\nFennville, MI  49408\r\n\r\nbobf@rafelectricinc.com\r\nrafelectricinc.com`;
    emailHyperlink = '';

    @ViewChild('inputComponent') inputComponent: any;

    constructor(public modalRef: BsModalRef, private uow: RAFUnitOfWork, private appInfo: AppInformationService, private auth: AuthenticationService) {}

    async ngOnInit() {
        this.email = this.uow.emailMessages.createEntity() as EmailMessage;
        this.email.to = `${!!this.defaultEmailAddress ? this.defaultEmailAddress : ''}`;
        this.email.created = new Date();
        this.email.createdById = this.auth.userValue.id;

        this.entity = await this.uow.invoices.byId(this.entityId);
        this.email.invoiceId = this.entityId;
        if (!this.entity.code) this.entity.code = core.getUuid();

        this.email.subject = `Invoice# ${this.entity.invoiceNumber}`;
        this.email.body = `${this.emailBodyMain}\r\n${this.emailSignature}`;
    }

    createHyperlink() {
        this.emailHyperlink = '';
        this.emailHyperlink = `${location.href.slice(0, location.href.indexOf(location.pathname))}/portal/invoice?code=${this.entity.code}`;
    }

    buildEmailBody = (e) => {
        this.email.body = null;

        if (!!this.email.includeStrip) {
            this.createHyperlink();
            this.email.body = `${this.emailBodyMain}\r\n\r\n${this.emailBodyCreditCard}\r\n\r\n${this.emailHyperlink}\r\n\r\n${this.emailSignature}`;
        } else {
            this.email.body = `${this.emailBodyMain}\r\n${this.emailSignature}`;
        }

        // tslint:disable-next-line: semicolon
    };

    async save() {
        const success = this.validate();
        if (!this.validate()) return;
        this.processing = true;
        await this.uow.commit();
        this.result.next({ success: true, value: this.email.id });
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig(this.validationGroup);
        if (groupConfig) {
            const result = validationEngine.validateGroup(this.validationGroup);
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before ${this.errorAction}.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }

    cancel() {
        this.uow.rollback();
        this.result.next({ success: false });
    }
}
